function enableInlineAutoplay(video) {
  video.muted = true;
  video.defaultMuted = true;
  video.playsInline = true;
  video.setAttribute('muted', '');
  video.setAttribute('playsinline', '');
  video.setAttribute('webkit-playsinline', '');
}

function tryPlayMuted(video) {
  if (!video.paused) return;
  enableInlineAutoplay(video);
  const playPromise = video.play();
  if (playPromise) playPromise.catch(() => {});
}

document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('.videoPlay');
  const autoplayVideos = [];

  videos.forEach((video) => {
    const button = document.querySelector(`[aria-controls="${video.id}"]`);
    const hasAutoplay = video.hasAttribute('autoplay');
    const soundIcon = document.querySelector(`[data-video-sound-icon="${video.id.replace('Video--', '')}"]`);

    // Function to update sound icon visibility (only if icon exists)
    const updateSoundIcon = () => {
      // Early return if no icon container exists
      if (!soundIcon) {
        return;
      }

      const unmutedIcon = soundIcon.querySelector('[data-icon-unmuted]');
      const mutedIcon = soundIcon.querySelector('[data-icon-muted]');

      // Early return if icon elements don't exist
      if (!unmutedIcon || !mutedIcon) {
        return;
      }

      const isMuted = video.muted || video.hasAttribute('muted');

      if (isMuted) {
        // Show muted icon (with strike-through)
        mutedIcon.classList.remove('opacity-0');
        mutedIcon.classList.add('opacity-100');
        unmutedIcon.classList.remove('opacity-100');
        unmutedIcon.classList.add('opacity-0');
      } else {
        // Show unmuted icon (without strike-through)
        unmutedIcon.classList.remove('opacity-0');
        unmutedIcon.classList.add('opacity-100');
        mutedIcon.classList.remove('opacity-100');
        mutedIcon.classList.add('opacity-0');
      }
    };

    // Initialize icon state (only if icon exists)
    if (soundIcon) {
      updateSoundIcon();
    }

    if (hasAutoplay) {
      autoplayVideos.push(video);
      video.preload = 'auto';
      tryPlayMuted(video);
      video.addEventListener('loadeddata', () => tryPlayMuted(video), { once: true });
      video.addEventListener('canplay', () => tryPlayMuted(video), { once: true });
    } else {
      video.preload = 'metadata';
      video.addEventListener('loadedmetadata', () => {
        video.currentTime = 0;
        video.pause();
      });
      video.pause();
      video.currentTime = 0;
    }

    // Handle button click (play/pause and unmute)
    if (button) {
      const playIcon = button.querySelector('[data-icon-play]');
      const pauseIcon = button.querySelector('[data-icon-pause]');

      button.addEventListener('click', (e) => {
        e.stopPropagation();
        if (video.paused) {
          // Unmute when starting playback via button
          video.muted = false;
          video.play();
          if (playIcon) playIcon.hidden = true;
          if (pauseIcon) pauseIcon.hidden = false;
        } else {
          video.pause();
          if (playIcon) playIcon.hidden = false;
          if (pauseIcon) pauseIcon.hidden = true;
        }
      });
    }

    // Handle direct video click (toggle mute/unmute only)
    video.addEventListener(
      'click',
      function (e) {
        console.log('Video click detected', {
          videoId: video.id,
          button: button,
          target: e.target,
          buttonContainsTarget: button && button.contains(e.target),
        });

        // Prevent event from firing multiple times
        e.stopPropagation();
        e.stopImmediatePropagation();

        // Don't trigger if clicking the button
        if (button && button.contains(e.target)) {
          console.log('Click was on button, ignoring');
          return;
        }

        console.log('Toggling mute state', {
          hasMuted: video.hasAttribute('muted'),
          muted: video.muted,
        });

        // Toggle mute state by removing/adding muted attribute and property
        if (video.hasAttribute('muted')) {
          video.removeAttribute('muted');
          video.muted = false;
          console.log('Removed muted attribute and set muted to false');
        } else {
          video.setAttribute('muted', '');
          video.muted = true;
          console.log('Added muted attribute and set muted to true');
        }

        // Update sound icon visibility (only if icon exists)
        if (soundIcon) {
          updateSoundIcon();
        }

        console.log('After toggle', {
          hasMuted: video.hasAttribute('muted'),
          muted: video.muted,
        });
      },
      { once: false, capture: true }
    );
  });

  if (autoplayVideos.length === 0) return;

  const playVisible = (video) => tryPlayMuted(video);

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) playVisible(entry.target);
        });
      },
      { threshold: 0.25 }
    );
    autoplayVideos.forEach((video) => observer.observe(video));
  }

  const retryAutoplay = () => {
    autoplayVideos.forEach((video) => tryPlayMuted(video));
  };
  document.addEventListener('touchstart', retryAutoplay, { passive: true, once: true });
  document.addEventListener('scroll', retryAutoplay, { passive: true, once: true });
});
